import { useCallback, useState } from 'react'
import { cargarFunctions } from '../lib/firebase'

const mensajesPorCodigo = {
  'functions/not-found': 'Este gatico ya no está disponible.',
  'functions/failed-precondition':
    'La consulta por WhatsApp aún no está habilitada. Escríbenos por otro medio.',
  'functions/invalid-argument': 'No pudimos identificar el gatico.',
}

/**
 * Dispara la consulta por WhatsApp de un gatico.
 *
 * El link lo arma una Cloud Function que lee nombre y precio desde Firestore,
 * de modo que el mensaje no se pueda alterar desde el navegador.
 */
export function usePedidoWhatsapp() {
  const [pendiente, setPendiente] = useState(null)
  const [error, setError] = useState(null)

  // comoReproductor solo tiene efecto real si el producto lo permite —la
  // Cloud Function es quien decide eso, mirando el propio documento en
  // Firestore, así que aquí simplemente se reenvía la elección del cliente.
  const pedir = useCallback(async (productoId, comoReproductor = false) => {
    // La pestaña se abre aquí, de forma síncrona dentro del gesto del usuario.
    // Si se abriera después del await, el bloqueador de pop-ups la descartaría.
    const ventana = window.open('', '_blank')
    if (ventana) ventana.opener = null

    setPendiente(productoId)
    setError(null)

    try {
      const { functions, httpsCallable } = await cargarFunctions()
      const generarLink = httpsCallable(functions, 'generarLinkPedidoWhatsapp')
      const { data } = await generarLink({ productoId, comoReproductor })

      if (ventana) ventana.location.href = data.url
      else window.location.href = data.url
    } catch (err) {
      ventana?.close()
      console.error('usePedidoWhatsapp:', err)
      setError(
        mensajesPorCodigo[err.code] ??
          'No pudimos abrir WhatsApp. Intenta de nuevo.'
      )
    } finally {
      setPendiente(null)
    }
  }, [])

  return { pedir, pendiente, error }
}
